import { inject, InjectFlags, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { filterNotNull } from '../rxjs';
import { AUTH_SERVICE, AuthService, AuthServiceUser } from './auth-service.token';

export const CURRENT_USER = new InjectionToken<Observable<AuthServiceUser>>('Current user', {
  providedIn: 'root',
  factory: () => {
    const authService: AuthService = inject(AUTH_SERVICE, InjectFlags.Optional);

    if (!authService) {
      throw new Error(`Must provide AUTH_SERVICE in order to use CURRENT_USER.`);
    }

    return authService.currentUser$.pipe(filterNotNull());
  }
})